Namespace 'Settings.Views.Topics'

class Settings.Views.Topics.ExternalStreamChannelView extends Settings.Views.Topics.ChannelView
  sourceClassName: 'Keepcon::ChannelSource'
  channelClassName: 'Keepcon::ExternalStream'
  sourceIcon: image_path('source_stream.png')
  template: JST['backbone/templates/settings/topics/external_stream_channel']

  initialize: ({sourceId, sourceIndex, nameInput, allowRemove}) ->
    @sourceId = sourceId
    @sourceIndex = sourceIndex
    @nameInput = nameInput
    @allowRemove = allowRemove

  render: ->
    @$el.html @template
      id: @sourceId
      index: @sourceIndex
      nameInput: @nameInput
      allowRemove: @allowRemove
      sourceClassName: @sourceClassName
      sourceIcon: @sourceIcon
      channelClassName: @channelClassName
    @
